const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

// fix 
const SECTION_SEL = '#shopify-section-template--17954321760442__1733735194aea140dc';
const BTN_SEL = '.button-search';

document.addEventListener('click', (e) => {
  const btn = e.target.closest(`${SECTION_SEL} ${BTN_SEL}`);
  if (!btn) return;

  if (btn.hasAttribute('disabled')) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
}, true); 